import { Col, Row } from "react-bootstrap";
import { faChartBar, faSearch } from '@fortawesome/free-solid-svg-icons';
import { formatDateInEN, formatInReal } from "../../commons/util/HallAppUtil";
import { useEffect, useState } from "react";

import AppLoading from "../../commons/AppLoading";
import CardCommand from "../commands/components/CardCommand";
import CommandAPI from "../commands/CommandAPI";
import EmployeeAPI from "../employee/EmployeeAPI";
import EmptyState from "../../commons/EmptyState";
import FloatingButton from "../../commons/buttons/FloatingButton";
import FloatingVideoButton from "../../commons/buttons/FloatingVideoButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import HallAppCenterContainer from "../../commons/containers/HallAppCenterContainer";
import HallAppToast from "../../commons/HallAppToast";
import InfiniteScroll from "react-infinite-scroll-component";
import MenuTitle from "../../commons/menu/MenuTitle";
import PullToRefresh from 'react-simple-pull-to-refresh';
import ReportAPI from "./ReportAPI";
import ReportHeader from "../report-full/components/ReportHeader";
import ReportModalFilter from "./components/ReportModalFilter";
import ReportSummaryPayments from "./components/ReportSummaryPayments";
import ReportValues from "./components/ReportValues";
import { useLocation } from "react-router-dom";

function Report() {

    const [transactionSummary, setTranstactionSummary] = useState({})
    const [isLoadingSummary, setIsLoadingSummary] = useState(true)
    const [showModalFilter, setShowModalFilter] = useState(false)
    // eslint-disable-next-line no-unused-vars
    const [isLoadingPage, setIsLoadingPage] = useState(false)
    const [commands, setCommands] = useState([])
    const [totalResultRows, setTotalResultRows] = useState(0);
    const [isSearchEmployee, setIsSerachEmployee] = useState(false)
    const [profits, setProfits] = useState(0)
    const [employeeSearchName, setEmployeeSearchName] = useState('')



    const commandAPI = new CommandAPI();
    const employeeAPI = new EmployeeAPI();


    const { search } = useLocation();
    const params = new URLSearchParams(search);
    const id = params.get("id");
    const statusQueryUrl = params.get("status");
    const startDateQueryUrl = params.get("startDate");
    const endDateQueryUrl = params.get("endDateDate");

    const [filter, setFilter] = useState({
        page: 0,
        limit: 50,
        status: statusQueryUrl || '',
        startDate: startDateQueryUrl || formatDateInEN(new Date()),
        endDate: endDateQueryUrl || formatDateInEN(new Date()),
    })

    useEffect(() => {
        const filter = {
            startDate: startDateQueryUrl || formatDateInEN(new Date()),
            endDate: endDateQueryUrl || formatDateInEN(new Date()),
            status: statusQueryUrl || '',
        }
        findReportSummary(filter);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (filter.page === 0) {
            setCommands([])
            setTotalResultRows(0)
        }
        findAllCommands(filter);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filter]);

    const findAllCommands = async () => {
        try {
            const response = await commandAPI.advancedSearch(id, filter)
            setCommands(prevItems => [...prevItems, ...response.data.content]);
            setTotalResultRows(response.data.totalResultRows)
        } catch (_) {
            setCommands([])
            setTotalResultRows(0)
        }
    };

    const reportAPI = new ReportAPI();

    async function findReportSummary(filter) {
        try {
            setIsLoadingSummary(true)
            const response = await reportAPI.getReportSummary(filter)
            setTranstactionSummary(response.data);
        } catch (_) {
            HallAppToast.genericError()
        } finally {
            setIsLoadingSummary(false)
        }
    }

    async function getFilter(data) {
        setShowModalFilter(false);
        findReportSummary(data);

        if (data.employeeId !== null && data.employeeId !== undefined) {
            setIsSerachEmployee(true)
            setEmployeeSearchName(data?.employeeName ?? '')
            await getProfits(data)
        } else {
            setIsSerachEmployee(false)
            setEmployeeSearchName(null)
        }

        setFilter({
            ...filter,
            page: 0,
            startDate: data.startDate,
            endDate: data.endDate,
            status: data.commandStatus,
            employeeId: data.employeeId,
            paymentType: data.paymentType
        })
    }

    async function getProfits(data) {
        try {
            // não chama API se employeeId não existir
            if (!data?.employeeId) return;

            const dataFilter = {
                startDate: data.startDate,
                endDate: data.endDate,
                employeeId: data.employeeId,
            };

            const response = await employeeAPI.getProfits(dataFilter);
            setProfits(response.data.value);
        } catch (_) {
            HallAppToast.error("Ocorreu um erro ao carregar seus lucros, tente novamente.");
        }
    }


    async function refresh() {
        findReportSummary({ ...filter, page: 0, });
        setCommands([]);
        setTotalResultRows(0)
        findAllCommands()
        if (filter.employeeId) {
            getProfits(filter)
        }
    }

    return (
        <>
            {(id || statusQueryUrl) && <ReportHeader name="Relatório Atendimento" />}
            <div className="container">
                <MenuTitle title='Relatórios Comandas' showArrowInfo={true} />

                <PullToRefresh onRefresh={refresh}>
                    <Row className="mb-3">
                        <Col xs={12} md={4} className="mb-3">
                            <ReportValues
                                isLoadingSummary={isLoadingSummary}
                                bgColor="#28a745"
                                value={formatInReal(transactionSummary?.totalReceived)}
                                label="total recebido"
                            />
                        </Col>

                        <Col xs={12} md={4} className="mb-3">
                            <ReportValues
                                textColor="black"
                                isLoadingSummary={isLoadingSummary}
                                bgColor="#ffc107"
                                value={formatInReal(transactionSummary?.totalToReceive)}
                                label="total á receber"
                            />
                        </Col>

                        <Col xs={12} md={4} className="mb-3">
                            <ReportValues
                                isLoadingSummary={isLoadingSummary}
                                bgColor="#17a2b8"
                                value={transactionSummary?.totalCustomer || 0}
                                label="cliente(s)"
                            />
                        </Col>

                        {isSearchEmployee && (
                            <Col xs={12} md={12} className="mb-3">
                                <ReportValues
                                    isLoadingSummary={isLoadingSummary}
                                    bgColor="#4718ad"
                                    value={formatInReal(profits) || 0}
                                    label={`Comissão do Profissional - ${employeeSearchName}`}
                                />
                            </Col>
                        )}
                    </Row>

                    <hr></hr>
                    <ReportSummaryPayments
                        transactionSummary={transactionSummary}
                        isLoadingSummary={isLoadingSummary} />
                    <hr></hr>

                    {isLoadingPage ? <HallAppCenterContainer><AppLoading /></HallAppCenterContainer> :
                        <InfiniteScroll
                            dataLength={commands.length}
                            key={commands.length}
                            next={() => {
                                if (commands.length < totalResultRows) {
                                    setFilter({
                                        ...filter,
                                        page: filter.page + 1,
                                    })
                                }
                            }}
                            hasMore={true}
                            loader={commands.length < totalResultRows && <HallAppCenterContainer><AppLoading /></HallAppCenterContainer>}
                            endMessage={
                                <p style={{ textAlign: 'center' }}>
                                    <b>Yay! Você já viu de tudo</b>
                                </p>
                            }
                        >
                            <Row style={{ margin: 0 }}>
                                {
                                    commands.length === 0 ? <EmptyState
                                        title="Nenhum resultado para o período"
                                        description="Não encontramos comandas no intervalo selecionado. Ajuste as datas para visualizar outros períodos."
                                        icon={<FontAwesomeIcon icon={faChartBar} />}
                                        actionLabel="Alterar datas"
                                        onAction={() => setShowModalFilter(true)}
                                    /> :
                                        commands.map(data => (
                                            <Col xs={12} sm={12} md={4} lg={4} key={data.id} style={{ marginBottom: '10px' }}>
                                                <CardCommand updateCommands={() => {
                                                    setFilter({
                                                        ...filter,
                                                        page: 0,
                                                    })
                                                }} command={data} />
                                            </Col>

                                        ))
                                }
                            </Row>
                        </InfiniteScroll>}

                    <div style={{ height: "calc(50px + 72px)" }}></div>
                    <FloatingVideoButton youtubeUrl={"https://www.youtube.com/embed/ifLb2FFFH1I"} />


                    <FloatingButton icon={faSearch} onClick={() => {
                        setShowModalFilter(true);
                    }} />

                    <ReportModalFilter
                        getFilter={getFilter}
                        show={showModalFilter}
                        closeShow={() => {
                            setShowModalFilter(false);
                        }} />
                </PullToRefresh>
            </div>
        </>
    );
}

export default Report;